interface AuthWrapperProps {
    children: React.ReactNode;
    footer?: React.ReactElement;
}

export default function AuthWrapper({ children, footer }: AuthWrapperProps) {
    return (
        <div className="mx-auto py-[64px] overflow-y-auto sm:mx-0 sm:py-0 sm:overflow-y-auto sm:flex items-center justify-center min-h-dvh sm:min-h-auto sm:h-dvh">
            <article
                className="rounded-r12 border border-strokedark
                 bg-[#F1F1F3] shadow-[0px_16px_32px_-12px_#0e121b19] w-[488px] max-w-[95%] mx-auto"
            >
                <div className="bg-white px-24 sm:px-48 pt-[32px] sm:pt-48 pb-40 rounded-r12">
                    <h2 className="uppercase text-primary text-xxl font-extrabold mb-24">
                        Mantle
                    </h2>
                    {children}
                </div>
                {footer && (
                    <div className="text-center py-[14px] text-sm text-[#525866] rounded-b-r12">
                        {footer}
                    </div>
                )}
            </article>
        </div>
    );
}
